import { useApiClient } from '@startupquickstart/frontend';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

interface GenerateThemeTranslationVoiceoversParams {
  attractionId: string;
  themeId: string;
  translationId: string;
  voiceoverType: 'both' | 'description' | 'long_description';
  voice: 'alloy' | 'echo' | 'fable' | 'onyx' | 'nova' | 'shimmer';
}

/**
 * Hook for generating theme translation voiceovers
 */
export function useGenerateThemeTranslationVoiceovers() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ attractionId, themeId, translationId, voiceoverType, voice }: GenerateThemeTranslationVoiceoversParams) => {
      return apiClient.post(
        `/attractions/${attractionId}/themes/${themeId}/translations/${translationId}/generate-voiceovers`,
        { voiceoverType, voice },
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ThemeTranslation'] });
      toast.success('Voiceovers generated successfully');
    },
    onError: (error: Error) => {
      toast.error(error?.message || 'Failed to generate voiceovers');
    },
  });
}
